<template>
  <div class="sizes-legend">    
    <svg class="root" ref="legendContainer"> </svg>
  </div>
</template>

<script>
import legend from '@/utils/ColorLegend'
import d3 from '@/utils/d3importer'

export default {
  name: "SizesLegend",
  props: ['sizeScale','ticks'],
  mounted () {
    this.draw()
  },
  methods:{
    draw(){
      // let tickSize = 6,
      //   width = 220, 
      //   height = 44 + tickSize,
      //   marginTop = 18,
      //   marginRight = 0,
      //   marginBottom = 16 + tickSize,
      //   marginLeft = 0,
      //   ticks = width / 64,
      //   tickFormat,
      //   tickValues
      let width = this.$refs.legendContainer.clientWidth
      let margin = 40  
      
      let x = d3.scaleLinear().domain(this.sizeScale.domain()).range([margin,width-margin])
      let svg = d3.select(this.$refs.legendContainer)
      let dom = this.sizeScale.domain()
      let ballsData = [dom[0],dom[0]+(dom[1]-dom[0])/2,dom[1]]
      let balls = svg.selectAll('.ball').data(ballsData)
      let ballsEnter = balls.enter().append('g').attr('class','ball')
      ballsEnter.append('circle').attr('fill','#4760DC')
      ballsEnter.append('text').attr('transform',`translate(0,25)`).attr('text-anchor','middle').style('font-size','11px')
      balls = balls.merge(ballsEnter)
      balls.attr('transform',(d,i)=>`translate(${x(d)},25)`)
      balls.select('text').text((d)=>parseFloat(d).toFixed(2))
      balls.select('circle').attr('r',(d)=>this.sizeScale(d))
    }
  },
  watch:{
    sizeScale () {
      this.draw()
    }
  }
}
</script>

<style scoped lang="stylus">
.sizes-legend
  width 100%
  height 50px
  display: flex
  .root 
    width 60%
    height 100%
    margin auto
    // border solid 1px
</style>